/**
 * Generato automaticamente.
 * OpenAPI
 */
import { useMutation, useQuery } from 'react-query';
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseQueryOptions,
  UseQueryResult,
} from 'react-query';
import { apiClientRequest } from '../../../client/apiClient';
import type { ErrorType } from '../../../client/apiClient';
import type {
  GetSezioniExportParams,
  GetSezioniParams,
  SezioneDTO,
  SezioneRequest,
  WsProblema,
  WsRispostaPaginataListSezioneDTO,
} from '.././schemas';

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

// eslint-disable-next-line
type SecondParameter<T extends (...args: any) => any> = T extends (
  config: any,
  args: infer P,
) => any
  ? P
  : never;

/**
 * Ottiene i dettagli di una sezione.
 * @summary Dettaglio Sezione
 */
export const getSezioniId = (
  id: string,
  options?: SecondParameter<typeof apiClientRequest>,
  signal?: AbortSignal,
) => {
  return apiClientRequest<SezioneDTO>(
    { url: `/framework-cfg-domande/sezioni/${id}`, method: 'get', signal },
    options,
  );
};

export const getGetSezioniIdQueryKey = (id: string) =>
  [`/framework-cfg-domande/sezioni/${id}`] as const;

export const getGetSezioniIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getSezioniId>>,
  TError = ErrorType<WsProblema>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getSezioniId>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryOptions<Awaited<ReturnType<typeof getSezioniId>>, TError, TData> & {
  queryKey: QueryKey;
} => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetSezioniIdQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSezioniId>>> = ({
    signal,
  }) => getSezioniId(id, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions };
};

export type GetSezioniIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSezioniId>>
>;
export type GetSezioniIdQueryError = ErrorType<WsProblema>;

/**
 * @summary Dettaglio Sezione
 */
export const useGetSezioniId = <
  TData = Awaited<ReturnType<typeof getSezioniId>>,
  TError = ErrorType<WsProblema>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getSezioniId>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetSezioniIdQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Aggiorna una sezione.
 * @summary Modifica Sezione
 */
export const putSezioniId = (
  id: string,
  sezioneRequest: SezioneRequest,
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  return apiClientRequest<SezioneDTO>(
    {
      url: `/framework-cfg-domande/sezioni/${id}`,
      method: 'put',
      headers: { 'Content-Type': 'application/json' },
      data: sezioneRequest,
    },
    options,
  );
};

export const getPutSezioniIdMutationOptions = <
  TError = ErrorType<WsProblema>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putSezioniId>>,
    TError,
    { id: string; data: SezioneRequest },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putSezioniId>>,
  TError,
  { id: string; data: SezioneRequest },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putSezioniId>>,
    { id: string; data: SezioneRequest }
  > = props => {
    const { id, data } = props ?? {};

    return putSezioniId(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutSezioniIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof putSezioniId>>
>;
export type PutSezioniIdMutationBody = SezioneRequest;
export type PutSezioniIdMutationError = ErrorType<WsProblema>;

/**
 * @summary Modifica Sezione
 */
export const usePutSezioniId = <
  TError = ErrorType<WsProblema>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putSezioniId>>,
    TError,
    { id: string; data: SezioneRequest },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions = getPutSezioniIdMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Esegue una cancellazione logica impostando data_cancellazione della sezione
 * @summary Elimina Sezione
 */
export const deleteSezioniId = (
  id: string,
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  return apiClientRequest<void>(
    { url: `/framework-cfg-domande/sezioni/${id}`, method: 'delete' },
    options,
  );
};

export const getDeleteSezioniIdMutationOptions = <
  TError = ErrorType<WsProblema>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteSezioniId>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteSezioniId>>,
  TError,
  { id: string },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteSezioniId>>,
    { id: string }
  > = props => {
    const { id } = props ?? {};

    return deleteSezioniId(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteSezioniIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteSezioniId>>
>;

export type DeleteSezioniIdMutationError = ErrorType<WsProblema>;

/**
 * @summary Elimina Sezione
 */
export const useDeleteSezioniId = <
  TError = ErrorType<WsProblema>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteSezioniId>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions = getDeleteSezioniIdMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Ritorna l'elenco delle sezioni.
 * @summary Elenco Sezioni
 */
export const getSezioni = (
  params?: GetSezioniParams,
  options?: SecondParameter<typeof apiClientRequest>,
  signal?: AbortSignal,
) => {
  return apiClientRequest<WsRispostaPaginataListSezioneDTO>(
    { url: `/framework-cfg-domande/sezioni`, method: 'get', params, signal },
    options,
  );
};

export const getGetSezioniQueryKey = (params?: GetSezioniParams) =>
  [`/framework-cfg-domande/sezioni`, ...(params ? [params] : [])] as const;

export const getGetSezioniQueryOptions = <
  TData = Awaited<ReturnType<typeof getSezioni>>,
  TError = ErrorType<unknown>,
>(
  params?: GetSezioniParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getSezioni>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryOptions<Awaited<ReturnType<typeof getSezioni>>, TError, TData> & {
  queryKey: QueryKey;
} => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetSezioniQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSezioni>>> = ({
    signal,
  }) => getSezioni(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions };
};

export type GetSezioniQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSezioni>>
>;
export type GetSezioniQueryError = ErrorType<unknown>;

/**
 * @summary Elenco Sezioni
 */
export const useGetSezioni = <
  TData = Awaited<ReturnType<typeof getSezioni>>,
  TError = ErrorType<unknown>,
>(
  params?: GetSezioniParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getSezioni>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetSezioniQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Crea una nuova sezione non collegata a nessun modulo.
 * @summary Crea Sezione
 */
export const postSezioni = (
  sezioneRequest: SezioneRequest,
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  return apiClientRequest<SezioneDTO>(
    {
      url: `/framework-cfg-domande/sezioni`,
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      data: sezioneRequest,
    },
    options,
  );
};

export const getPostSezioniMutationOptions = <
  TError = ErrorType<WsProblema>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postSezioni>>,
    TError,
    { data: SezioneRequest },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postSezioni>>,
  TError,
  { data: SezioneRequest },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postSezioni>>,
    { data: SezioneRequest }
  > = props => {
    const { data } = props ?? {};

    return postSezioni(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostSezioniMutationResult = NonNullable<
  Awaited<ReturnType<typeof postSezioni>>
>;
export type PostSezioniMutationBody = SezioneRequest;
export type PostSezioniMutationError = ErrorType<WsProblema>;

/**
 * @summary Crea Sezione
 */
export const usePostSezioni = <
  TError = ErrorType<WsProblema>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postSezioni>>,
    TError,
    { data: SezioneRequest },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions = getPostSezioniMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Crea una nuova sezione per import.
 * @summary Crea Sezione
 */
export const postSezioniImport = (
  sezioneDTO: SezioneDTO,
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  return apiClientRequest<SezioneDTO>(
    {
      url: `/framework-cfg-domande/sezioni/import`,
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      data: sezioneDTO,
    },
    options,
  );
};

export const getPostSezioniImportMutationOptions = <
  TError = ErrorType<WsProblema>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postSezioniImport>>,
    TError,
    { data: SezioneDTO },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postSezioniImport>>,
  TError,
  { data: SezioneDTO },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postSezioniImport>>,
    { data: SezioneDTO }
  > = props => {
    const { data } = props ?? {};

    return postSezioniImport(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostSezioniImportMutationResult = NonNullable<
  Awaited<ReturnType<typeof postSezioniImport>>
>;
export type PostSezioniImportMutationBody = SezioneDTO;
export type PostSezioniImportMutationError = ErrorType<WsProblema>;

/**
 * @summary Crea Sezione
 */
export const usePostSezioniImport = <
  TError = ErrorType<WsProblema>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postSezioniImport>>,
    TError,
    { data: SezioneDTO },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions = getPostSezioniImportMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Controllo se il tag semantico viene utilizzato nelle sezioni
 * @summary Check tag semantico in sezioni
 */
export const getSezioniIdTagSemanticoIsDeletable = (
  idTagSemantico: string,
  options?: SecondParameter<typeof apiClientRequest>,
  signal?: AbortSignal,
) => {
  return apiClientRequest<boolean>(
    {
      url: `/framework-cfg-domande/sezioni/${idTagSemantico}/isDeletable`,
      method: 'get',
      signal,
    },
    options,
  );
};

export const getGetSezioniIdTagSemanticoIsDeletableQueryKey = (
  idTagSemantico: string,
) => [`/framework-cfg-domande/sezioni/${idTagSemantico}/isDeletable`] as const;

export const getGetSezioniIdTagSemanticoIsDeletableQueryOptions = <
  TData = Awaited<ReturnType<typeof getSezioniIdTagSemanticoIsDeletable>>,
  TError = ErrorType<unknown>,
>(
  idTagSemantico: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getSezioniIdTagSemanticoIsDeletable>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryOptions<
  Awaited<ReturnType<typeof getSezioniIdTagSemanticoIsDeletable>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetSezioniIdTagSemanticoIsDeletableQueryKey(idTagSemantico);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getSezioniIdTagSemanticoIsDeletable>>
  > = ({ signal }) =>
    getSezioniIdTagSemanticoIsDeletable(idTagSemantico, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!idTagSemantico, ...queryOptions };
};

export type GetSezioniIdTagSemanticoIsDeletableQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSezioniIdTagSemanticoIsDeletable>>
>;
export type GetSezioniIdTagSemanticoIsDeletableQueryError = ErrorType<unknown>;

/**
 * @summary Check tag semantico in sezioni
 */
export const useGetSezioniIdTagSemanticoIsDeletable = <
  TData = Awaited<ReturnType<typeof getSezioniIdTagSemanticoIsDeletable>>,
  TError = ErrorType<unknown>,
>(
  idTagSemantico: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getSezioniIdTagSemanticoIsDeletable>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetSezioniIdTagSemanticoIsDeletableQueryOptions(
    idTagSemantico,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Ritorna l'elenco delle sezioni.
 * @summary Elenco Sezioni
 */
export const getSezioniExport = (
  params?: GetSezioniExportParams,
  options?: SecondParameter<typeof apiClientRequest>,
  signal?: AbortSignal,
) => {
  return apiClientRequest<WsRispostaPaginataListSezioneDTO>(
    {
      url: `/framework-cfg-domande/sezioni/export`,
      method: 'get',
      params,
      signal,
    },
    options,
  );
};

export const getGetSezioniExportQueryKey = (params?: GetSezioniExportParams) =>
  [
    `/framework-cfg-domande/sezioni/export`,
    ...(params ? [params] : []),
  ] as const;

export const getGetSezioniExportQueryOptions = <
  TData = Awaited<ReturnType<typeof getSezioniExport>>,
  TError = ErrorType<unknown>,
>(
  params?: GetSezioniExportParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getSezioniExport>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryOptions<
  Awaited<ReturnType<typeof getSezioniExport>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetSezioniExportQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getSezioniExport>>
  > = ({ signal }) => getSezioniExport(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions };
};

export type GetSezioniExportQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSezioniExport>>
>;
export type GetSezioniExportQueryError = ErrorType<unknown>;

/**
 * @summary Elenco Sezioni
 */
export const useGetSezioniExport = <
  TData = Awaited<ReturnType<typeof getSezioniExport>>,
  TError = ErrorType<unknown>,
>(
  params?: GetSezioniExportParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getSezioniExport>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetSezioniExportQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};
